export enum ThreeDotsActionsEnum {
    EDIT = 0,
    DUPLICATE = 1,
    DELETE = 2,
    PUBLISH = 3,
    MANAGE_CLIENTS = 4,
	ADD_TRANSLATIONS = 5,
	CHANGE_QUIZ_PERCENTAGE = 6,

};
